/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ networkName: NonNullable<unknown> }} Page_Title_Network_DataInputs */

const fr_page_title_network_data = /** @type {(inputs: Page_Title_Network_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.networkName} – Données – Bus Tracker`)
};

const en_page_title_network_data = /** @type {(inputs: Page_Title_Network_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.networkName} – Data – Bus Tracker`)
};

/**
* | output |
* | --- |
* | "{networkName} – Data – Bus Tracker" |
*
* @param {Page_Title_Network_DataInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title_network_data = /** @type {((inputs: Page_Title_Network_DataInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Network_DataInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_page_title_network_data(inputs)
	return en_page_title_network_data(inputs)
});